import { SERVICES } from '../../../core/constants/landing';
import { IconFilm, IconMonitor, IconSliders, IconVideoCamera } from '../../../common/icons';
import Reveal from '../../../common/components/Reveal/Reveal';

import '../styles/services.css';

const SERVICE_ICONS = {
    production: IconFilm,
    rental: IconVideoCamera,
    advisory: IconSliders,
    events: IconMonitor,
};

export default function Services() {
    return (
        <section id="servicios" className="services section" aria-labelledby="services-title">
            <div className="container">
                <Reveal className="services__header">
                    <p className="eyebrow">Servicios</p>
                    <h2 id="services-title" className="section__title">
                        Producción, equipos y técnica audiovisual
                    </h2>
                </Reveal>

                <ol className="services__grid">
                    {SERVICES.map((service, index) => {
                        const ServiceIcon = SERVICE_ICONS[service.id];
                        return (
                            <Reveal as="li" className="services__card" key={service.id}>
                                <div className="services__card-top">
                                    <span className="services__number" aria-hidden="true">
                                        {String(index + 1).padStart(2, '0')}
                                    </span>
                                    <span className="services__icon"><ServiceIcon /></span>
                                </div>
                                <h3 className="services__title">{service.title}</h3>
                                <p className="services__text">{service.text}</p>
                            </Reveal>
                        );
                    })}
                </ol>
            </div>
        </section>
    );
}
